import { useStations } from "../lib/useStations";
import StationList from "./StationList";

export default function AllStations() {
  const state = useStations();

  if (state.status === "loading") return <p className="text-slate-600">Loading stations…</p>;
  if (state.status === "error") return <p className="text-red-700">Failed to load stations: {state.error}</p>;

  return <StationList stations={state.stations} emptyMessage="The playlist has no stations." />;
}
